import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";

import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import VuiBox from "components/VuiBox";
import useCommon from "hooks/useCommon";

const StatusConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  action, // "activate" | "deactivate"
  userName,
}) => {
  const { STORE } = useCommon();
  const { statusUpdateLoading } = STORE((state) => state.user);
  const isDeactivate = action === "deactivate";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <VuiTypography variant="h6">
          {isDeactivate ? "Deactivate User" : "Activate User"}
        </VuiTypography>
      </DialogTitle>

      <DialogContent>
        <VuiTypography variant="body2">
          {isDeactivate ? (
            <VuiBox>
              <VuiBox mb={1}>
                <VuiTypography variant="body">
                  Are you sure you want to deactivate <strong>{userName}</strong>?
                </VuiTypography>
              </VuiBox>

              <VuiTypography variant="caption">
                This user will no longer be able to access the system.
              </VuiTypography>
            </VuiBox>
          ) : (
            <VuiBox>
              <VuiBox mb={1}>
                <VuiTypography variant="body">
                  Are you sure you want to activate <strong>{userName}</strong>?
                </VuiTypography>
              </VuiBox>

              <VuiTypography variant="caption">
                This user will regain access to the system.
              </VuiTypography>
            </VuiBox>
          )}
        </VuiTypography>
      </DialogContent>

      <DialogActions>
        <VuiButton variant="outlined" color="primary" onClick={onClose}>
          Cancel
        </VuiButton>

        <VuiButton
          color={isDeactivate ? "error" : "success"}
          onClick={onConfirm}
          disabled={statusUpdateLoading}
        >
          {statusUpdateLoading ? "Updating..." : isDeactivate ? "Deactivate" : "Activate"}
        </VuiButton>
      </DialogActions>
    </Dialog>
  );
};

export default StatusConfirmationDialog;
